import useEffects from '../hook/use-effects';

export default function Lifecycle(): null {
  useEffects();
  
  return null;
}
